import useSWR, { BareFetcher } from 'swr';

import { ProblemAndAnswer } from '@gmm/sdk-voodoo/shared';
import { useSnackbar } from '~/lib/hooks/useSnackbar';
import { useMigratedEndpoint } from '~/lib/hooks/voodoo/useMigratedEndpoint';
import { augmentSWR, sdkFetcher, swrKeyFor, voodooSdkFetcher } from '~/lib/swr';

import { ProblemFromSWR } from '../problemPreview';

import { dedupingInterval } from './utils';

interface Config {
  skillType: string;
  enabled?: boolean;
}

export const useExampleProblem = ({
  skillType,
  enabled = true,
}: Config): ProblemFromSWR => {
  const { enqueueGenericError } = useSnackbar();

  const isVoodooEndpoint = useMigratedEndpoint('skills-show');
  const fetcher = isVoodooEndpoint ? voodooSdkFetcher : sdkFetcher;

  const swrKey = swrKeyFor(() =>
    skillType ? ['skills.show', skillType, undefined] : null,
  );

  return useSWR<ProblemAndAnswer>(enabled ? swrKey : null, {
    dedupingInterval,
    fetcher: fetcher as BareFetcher<ProblemAndAnswer>,
    onError: () => enqueueGenericError(),
    use: [augmentSWR('problemData', ({ data }) => data)],
  }) as ProblemFromSWR;
};
